<div class="step-container">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="registration-get-provider-block mb-5" *ngIf="!loading">
      <div class="d-flex d-lg-none justify-content-center">
        <img src="assets/images/login-registration/registration-logo.svg" class="logo mb-3" />
      </div>
      <h5 class="get-provider-details-retriving-label text-center text-lg-start">
        {{ 'fgbcl.registration.get.provider.details.retriving.information.label.text' | translate }}
      </h5>
    </div>
    <ng-container *ngIf="loading">
      <div class="w-100">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </ng-container>
    <div class="registration-navigataion-button-container">
      <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
    </div>
  </div>
</div>
